module.exports = __webpack_public_path__ + "img/map-view-bg.8ee0e789.png";